import request from '@/utils/request'

export const mappingPoint = {}
export const mappingCheck = {}

// init mapping
const __createMappingPointList = (method, type) => (id, data) => request({
  method,
  url: `/trace/product/mapping/${type}/${id}`,
  data
})

// init mapping point
;['get', 'put', 'delete'].forEach((method) => {
  mappingPoint[method] = __createMappingPointList(method, 'point')
})

// init mapping check
;['get', 'put', 'delete'].forEach((method) => {
  mappingCheck[method] = __createMappingPointList(method, 'check')
})

export const postCheckItemsEdit = (data) => {
  return request({
    method: 'post',
    url: '/trace/check/items',
    data
  })
}

export const putCheckItemsAdd = (data) => {
  return request({
    method: 'put',
    url: '/trace/check/items',
    data
  })
}

export const getCheckItemsDetail = (id) => {
  return request({
    url: `/trace/check/items/${id}`
  })
}

export const deleteCheckItemsDel = (id) => {
  return request({
    method: 'delete',
    url: `/trace/check/items/${id}`
  })
}

export const delCheckItemsList = (data) => {
  return request({
    method: 'delete',
    url: '/trace/check/items/all',
    data
  })
}
